import { api } from "@/frontend/services/api";
import type {
  TournamentTeamPlayerQueryDTO,
  CreateTournamentTeamPlayerRequestDTO,
  UpdateTournamentTeamPlayerRequestDTO,
  TournamentTeamPlayerResponseDTO,
  TournamentTeamPlayersPaginatedResponseDTO,
  ApiResponse,
} from "@/shared/dto";

const BASE_URL = "/tournament-team-players/private";

export const tournamentTeamPlayerService = {
  getPaginate: (params?: Partial<TournamentTeamPlayerQueryDTO>) =>
    api.getWithParams<ApiResponse<TournamentTeamPlayersPaginatedResponseDTO>>(BASE_URL, params),
  getById: (id: string) =>
    api.get<ApiResponse<TournamentTeamPlayerResponseDTO>>(`${BASE_URL}/${id}`),
  create: (data: CreateTournamentTeamPlayerRequestDTO) =>
    api.post<ApiResponse<TournamentTeamPlayerResponseDTO>>(BASE_URL, data),
  update: (id: string, data: UpdateTournamentTeamPlayerRequestDTO) =>
    api.put<ApiResponse<TournamentTeamPlayerResponseDTO>>(`${BASE_URL}/${id}`, data),
  delete: (id: string) =>
    api.delete<ApiResponse<void>>(`${BASE_URL}/${id}`),
};
